import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=ab6c75fc&scoped=true&"
import script from "./Kiosk.vue?vue&type=script&lang=js&"
export * from "./Kiosk.vue?vue&type=script&lang=js&"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=ab6c75fc&scoped=true&lang=css&"
import style1 from "./Kiosk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6c75fc",
  null
  
)

export default component.exports